import { observer } from 'mobx-react-lite'
import React, { useContext, useEffect, useState } from 'react'
import ReactMultiSelect from '../../../FormComponents/ReactMultiSelect'
import { SearchContext } from '../../../../contexts/SearchContext'
import axiosService from '../../../../utils/AxiosService'

export default observer(function SearchByTag() {
  const { search, tagsVersion } = useContext(SearchContext)
  const [tagOptions, setTagOptions] = useState([])

  const getTagOptions = () => {
    axiosService.get('/api/project_manager/tags')
      .then((tags) => {
        setTagOptions(tags.map((tag) => ({ label: tag.name, value: tag.id })))
      })
  }

  useEffect(() => getTagOptions(), [tagsVersion])

  const setTagFilter = (tags) => {
      search.tags = tags.map(tag => tag.value)
      search.selectedTags = tags
  }

  return (
    <div className="w-72 shrink-0">
      <ReactMultiSelect
        placeholder="Filter by tags"
        value={search.selectedTags}
        options={tagOptions}
        onChange={setTagFilter}
        name="tag"
        hasSelectAll={false}
        disableSearch={false}
        limitDisplayedItems={2}
      />
    </div>
  )
})